"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "40", height: "38", viewBox: "0 0 40 38", className: "Icon payment-star", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M20 30.5L8.832 36.371l2.133-12.435-9.035-8.807 12.486-1.815L20 2l5.584 11.314L38.07 15.13l-9.035 8.807 2.133 12.435z", stroke: "#F4511C", fill: "none", strokeLinejoin: "round", strokeLinecap: "round", fillRule: "evenodd", strokeWidth: "3" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/payment-star.js
// module id = 1823
// module chunks = 0